import { defineStore } from 'pinia'

import type { CustomerCreditsStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useCustomerCreditsStore = defineStore('customer-credits', {
  state: (): CustomerCreditsStore => ({
    program: null,
    referrals: [],
    referralsMeta: null,
    referralsLoading: false,
    transactions: [],
    transactionsMeta: null,
    transactionsLoading: false,
    processing: false,
    modalEdit: false,
  }),
  actions,
  getters,
})
